import { Collection } from 'core/model';
import RoleSetGlobalFilterModel from './RoleSetGlobalFilterModel';

/**
 * Scopes granted to a single role set. There is no `url` because the rows are
 * always fetched through the owning role set, never company wide.
 */
export default class RoleSetGlobalFilterCollection extends Collection {
  get defaultSortState() {
    return {
      field: 'name',
      direction: 'asc'
    };
  }

  get model() {
    return RoleSetGlobalFilterModel;
  }

  get filterFieldWhitelist() {
    return new Set(['name', 'description']);
  }
}
